import { tv } from "@utils/tw"
import single from "@views/single"
import { defineBlock, EditableText, InnerBlocks, useInlineEditableValue } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Large Logo Grid",
  description: "One or more logos in a grid",
  icon: "star-filled",
  tags: ["#subpage-layout"],
  flags: {
    fullWidth: true,
    marginRule: "long-card",
  },
  blockStyles: [
    {
      label: "Small",
      name: "sm",
      isDefault: true,
    },
    {
      label: "Medium",
      name: "md",
    },
    {
      label: "Large",
      name: "lg",
    },
  ],
}

export default defineBlock("content/logos", (props) => {
  const [title, setTitle] = useInlineEditableValue("title", "Enter a title")
  const showTitle = env.admin || title !== "Enter a title"

  return (
    <div className="w-grid mx-auto">
      {showTitle && (
        <div className="w-full mb-5">
          <EditableText store="title" as="p" className="type-label-caps" placeholder="Enter a title" />
        </div>
      )}
      <div className={env.admin ? "" : layout({ size: props.blockStyle })}>
        <InnerBlocks
          orientation="horizontal"
          defaultBlocks={[["content/logo-item", {}]]}
          allowedBlocks={["content/logo-item"]}
          adminClassName={layout({ size: props.blockStyle })}
          appender={{ type: "simple" }}
        />
      </div>
    </div>
  )
})

const layout = tv({
  base: "grid w-full items-center gap-5 [&_.admin-message-box]:w-full [&_.admin-message-box]:h-full [&_.admin-message-box]:absolute [&_.admin-message-box]:top-0 [&_.admin-message-box]:left-0 [&_.admin-message-box]:flex [&_.admin-message-box]:items-center [&_.admin-message-box]:justify-center",
  variants: {
    size: {
      sm: "grid-cols-4 md:grid-cols-7 lg:grid-cols-8",
      md: "grid-cols-3 md:grid-cols-6 lg:grid-cols-7",
      lg: "grid-cols-2 md:grid-cols-5 lg:grid-cols-6",
    },
  },
  defaultVariants: {
    size: "md",
  },
})
